import { styled, IconButton, ToggleButtonGroup as UiToggleButtonGroup } from "@l2r-front/l2r-ui"

export const Container = styled("div")(({ theme }) => ({
    width: "fit-content",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    borderRadius: theme.spacing(3),

    "& > button, & > * > button": {
        width: "auto",
        height: "auto",
        display: "inline-flex",
        padding: "5px 6px",

        "&.Mui-selected:hover": {
            backgroundColor: theme.palette["primary"].dark,
        },
    },
}))

const TOGGLE_BUTTON_GROUP_HEIGHT = 36

export const ToggleButtonGroup = styled(UiToggleButtonGroup)((({ theme }) => ({
    overflowX: "auto",

    "&.MuiToggleButtonGroup-root": {
        border: 0,
        borderRadius: theme.spacing(3),
        height: TOGGLE_BUTTON_GROUP_HEIGHT,

        ".MuiToggleButtonGroup-grouped": {
            border: 0,
            borderRadius: theme.spacing(3),
        },

        ".MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            ":before": {
                content: "''",
                position: "absolute",
                right: 0,
                bottom: TOGGLE_BUTTON_GROUP_HEIGHT / 4,
                width: 1,
                height: TOGGLE_BUTTON_GROUP_HEIGHT / 2 - 1,
                borderRight: `1px solid ${theme.palette.divider}`,
            },
        },
    },
})))

export const RestoreButton = styled(IconButton)(() => ({
    border: "0 !important",
    padding: "0 !important",
}))